import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3bfa050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = { class: "row-wrapper-space-between" }
const _hoisted_3 = { class: "grid-group-of-two pt-3" }
const _hoisted_4 = { class: "form-item grid-group-of-two-first" }
const _hoisted_5 = { class: "form-item grid-group-of-two-second" }
const _hoisted_6 = { class: "grid-group-of-two" }
const _hoisted_7 = { class: "form-item grid-group-of-two-first" }
const _hoisted_8 = { class: "email-with-error-wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "pi pi-exclamation-triangle"
}
const _hoisted_10 = {
  key: 0,
  class: "form-item grid-group-of-two-second"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Suggestions", -1))
const _hoisted_12 = {
  class: "pl-2 ml-2 mt-0",
  style: {"line-height":"1.5"}
}
const _hoisted_13 = { class: "grid-group-of-two" }
const _hoisted_14 = { class: "form-item grid-group-of-two-first" }
const _hoisted_15 = { class: "grid-group-of-two" }
const _hoisted_16 = { class: "form-item grid-group-of-two-first" }
const _hoisted_17 = { class: "form-item grid-group-of-two-second" }
const _hoisted_18 = { class: "grid-group-of-two" }
const _hoisted_19 = { class: "form-item grid-group-of-two-first" }
const _hoisted_20 = { class: "form-item grid-group-of-two-second" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "right-aligned-items" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "grid-group-of-two" }
const _hoisted_25 = { class: "form-item grid-group-of-two-first" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Suggestions", -1))
const _hoisted_27 = {
  class: "pl-2 ml-2 mt-0",
  style: {"line-height":"1.5"}
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "grid-group-of-two" }
const _hoisted_30 = { class: "form-item grid-group-of-two-first" }
const _hoisted_31 = { class: "form-item grid-group-of-two-second" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Suggestions", -1))
const _hoisted_33 = {
  class: "pl-2 ml-2 mt-0",
  style: {"line-height":"1.5"}
}
const _hoisted_34 = { class: "pt-2" }
const _hoisted_35 = { class: "label" }
const _hoisted_36 = { class: "label" }
const _hoisted_37 = { class: "label" }
const _hoisted_38 = { class: "label" }
const _hoisted_39 = { class: "label" }
const _hoisted_40 = { class: "label" }
const _hoisted_41 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsButton = _resolveComponent("AsButton")!
  const _component_AsBlock = _resolveComponent("AsBlock")!
  const _component_AsInput = _resolveComponent("AsInput")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Password = _resolveComponent("Password")!
  const _component_AsDropdown = _resolveComponent("AsDropdown")!
  const _component_AsLabeledBlock = _resolveComponent("AsLabeledBlock")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_AsSwitch = _resolveComponent("AsSwitch")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AsBlock, { class: "row-wrapper-space-between" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(`${_ctx.$t('user.title')}  ${_ctx.getValueOrEmpty(_ctx.user.lastName)} ${_ctx.getValueOrEmpty(_ctx.user.firstName)}`), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AsButton, {
            type: _ctx.buttonTypes.Primary,
            disabled: !_ctx.isFormValid,
            label: _ctx.userId ? _ctx.$t('update') : _ctx.$t('create'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.processUserSubmit()))
          }, null, 8, ["type", "disabled", "label"]),
          _createVNode(_component_AsButton, {
            type: _ctx.buttonTypes.Outlined,
            label: _ctx.user.id ? _ctx.$t('back') : _ctx.$t('cancel'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel()))
          }, null, 8, ["type", "label"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_AsBlock, null, {
      default: _withCtx(() => [
        _createVNode(_component_AsLabeledBlock, {
          header: _ctx.$t('user.baseData')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_AsInput, {
                  type: "text",
                  label: _ctx.$t('user.lastName'),
                  value: _ctx.user.lastName,
                  onUpdate: _cache[2] || (_cache[2] = (value) => (_ctx.user.lastName = value))
                }, null, 8, ["label", "value"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_AsInput, {
                  type: "text",
                  label: _ctx.$t('user.firstName'),
                  value: _ctx.user.firstName,
                  onUpdate: _cache[3] || (_cache[3] = (value) => (_ctx.user.firstName = value))
                }, null, 8, ["label", "value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.$t('case.personalData.Email')) + " ", 1),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["form-control", { error: !_ctx.isEmailValid }]),
                    type: "email",
                    id: "email",
                    name: "email",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.email) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.user.email]
                  ]),
                  (!_ctx.isEmailValid)
                    ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_9, null, 512)), [
                        [_directive_tooltip, { value: _ctx.$t('invalidEmail'), showDelay: 1000, hideDelay: 300 }]
                      ])
                    : _createCommentVNode("", true)
                ])
              ]),
              (!_ctx.user.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.password')), 1),
                    _createVNode(_component_Password, {
                      modelValue: _ctx.userPassword,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userPassword) = $event)),
                      toggleMask: ""
                    }, {
                      footer: _withCtx(() => [
                        _createVNode(_component_Divider),
                        _hoisted_11,
                        _createElementVNode("ul", _hoisted_12, [
                          _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule1')), 1),
                          _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule2')), 1),
                          _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule3')), 1),
                          _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule4')), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_AsInput, {
                  type: "text",
                  label: _ctx.$t('user.phone'),
                  value: _ctx.user.phone,
                  onUpdate: _cache[6] || (_cache[6] = (value) => (_ctx.user.phone = value))
                }, null, 8, ["label", "value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_AsInput, {
                  type: "text",
                  label: _ctx.$t('user.city'),
                  value: _ctx.user.city,
                  onUpdate: _cache[7] || (_cache[7] = (value) => (_ctx.user.city = value))
                }, null, 8, ["label", "value"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_AsInput, {
                  type: "text",
                  label: _ctx.$t('user.airline'),
                  value: _ctx.user.airline,
                  onUpdate: _cache[8] || (_cache[8] = (value) => (_ctx.user.airline = value))
                }, null, 8, ["label", "value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_AsDropdown, {
                  label: _ctx.$t('user.function'),
                  placeholder: _ctx.$t('user.function'),
                  clearIcon: true,
                  value: _ctx.user.functionId,
                  options: _ctx.getLookUpOptions(_ctx.lvTypes.Function),
                  optionValue: 'id',
                  optionLabel: 'value',
                  onUpdate: _cache[9] || (_cache[9] = (value) => (_ctx.user.functionId = value))
                }, null, 8, ["label", "placeholder", "value", "options"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_AsInput, {
                  type: "text",
                  label: _ctx.$t('user.nearestAirport'),
                  value: _ctx.user.nearestAirport,
                  onUpdate: _cache[10] || (_cache[10] = (value) => (_ctx.user.nearestAirport = value))
                }, null, 8, ["label", "value"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }),
    (_ctx.user.id && (_ctx.isCurrentUser || _ctx.isCurrentUserAdmin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_AsBlock, {
            class: "pass-block",
            header: _ctx.$t('user.password.title')
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_AsButton, {
                  type: _ctx.buttonTypes.Primary,
                  disabled: !_ctx.isPassFormValid,
                  label: _ctx.$t('update'),
                  onClick: _ctx.processEditPasswordSubmit
                }, null, 8, ["type", "disabled", "label", "onClick"]),
                _createVNode(_component_AsButton, {
                  type: _ctx.buttonTypes.Outlined,
                  disabled: !_ctx.updatePasswordCommand.oldPassword && !_ctx.updatePasswordCommand.newPassword,
                  label: 'Cancel',
                  onClick: _ctx.processEditPasswordCancel
                }, null, 8, ["type", "disabled", "onClick"]),
                _createVNode(_component_ConfirmPopup)
              ])
            ]),
            default: _withCtx(() => [
              (_ctx.isCurrentUserAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t('user.password.new')), 1),
                        _createVNode(_component_Password, {
                          modelValue: _ctx.updatePasswordCommand.newPassword,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.updatePasswordCommand.newPassword) = $event)),
                          toggleMask: ""
                        }, {
                          footer: _withCtx(() => [
                            _createVNode(_component_Divider),
                            _hoisted_26,
                            _createElementVNode("ul", _hoisted_27, [
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule1')), 1),
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule2')), 1),
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule3')), 1),
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule4')), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t('user.password.old')), 1),
                        _createVNode(_component_Password, {
                          modelValue: _ctx.updatePasswordCommand.oldPassword,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.updatePasswordCommand.oldPassword) = $event)),
                          toggleMask: "",
                          feedback: false
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t('user.password.new')), 1),
                        _createVNode(_component_Password, {
                          modelValue: _ctx.updatePasswordCommand.newPassword,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.updatePasswordCommand.newPassword) = $event)),
                          toggleMask: ""
                        }, {
                          footer: _withCtx(() => [
                            _createVNode(_component_Divider),
                            _hoisted_32,
                            _createElementVNode("ul", _hoisted_33, [
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule1')), 1),
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule2')), 1),
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule3')), 1),
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.password.rule4')), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]))
            ]),
            _: 1
          }, 8, ["header"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AsBlock, null, {
      default: _withCtx(() => [
        _createVNode(_component_AsLabeledBlock, {
          header: _ctx.$t('user.permissions')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_AsSwitch, {
                customClass: 'row-wrapper',
                disabled: _ctx.isCurrentUser,
                value: !_ctx.user.isDeleted,
                onUpdate: _cache[14] || (_cache[14] = (update) => (_ctx.user.isDeleted = !update))
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('user.isActive')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "value"]),
              _createVNode(_component_AsSwitch, {
                customClass: 'row-wrapper',
                value: _ctx.userHasRole(_ctx.appRoles.SystemAdministrator),
                disabled: _ctx.isCurrentUser,
                onUpdate: _cache[15] || (_cache[15] = () => _ctx.toggleUserRole(_ctx.appRoles.SystemAdministrator))
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t(_ctx.appRoles.SystemAdministrator)), 1)
                ]),
                _: 1
              }, 8, ["value", "disabled"]),
              _createVNode(_component_AsSwitch, {
                customClass: 'row-wrapper',
                value: _ctx.userHasRole(_ctx.appRoles.StatisticUser),
                disabled: !_ctx.isCurrentUserAdmin,
                onUpdate: _cache[16] || (_cache[16] = () => _ctx.toggleUserRole(_ctx.appRoles.StatisticUser))
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t(_ctx.appRoles.StatisticUser)), 1)
                ]),
                _: 1
              }, 8, ["value", "disabled"]),
              _createVNode(_component_AsSwitch, {
                customClass: 'row-wrapper',
                value: _ctx.userHasRole(_ctx.appRoles.CaseManager),
                disabled: !_ctx.isCurrentUserAdmin,
                onUpdate: _cache[17] || (_cache[17] = () => _ctx.toggleUserRole(_ctx.appRoles.CaseManager))
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t(_ctx.appRoles.CaseManager)), 1)
                ]),
                _: 1
              }, 8, ["value", "disabled"]),
              _createVNode(_component_AsSwitch, {
                customClass: 'row-wrapper',
                value: _ctx.userHasRole(_ctx.appRoles.GroupAdmin),
                disabled: !_ctx.isCurrentUserAdmin,
                onUpdate: _cache[18] || (_cache[18] = () => _ctx.toggleUserRole(_ctx.appRoles.GroupAdmin))
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t(_ctx.appRoles.GroupAdmin)), 1)
                ]),
                _: 1
              }, 8, ["value", "disabled"]),
              _createVNode(_component_AsSwitch, {
                customClass: 'row-wrapper',
                disabled: !_ctx.isCurrentUserAdmin,
                value: _ctx.userHasRole(_ctx.appRoles.Therapist),
                onUpdate: _cache[19] || (_cache[19] = () => _ctx.toggleUserRole(_ctx.appRoles.Therapist))
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t(_ctx.appRoles.Therapist)), 1)
                ]),
                _: 1
              }, 8, ["disabled", "value"]),
              _createVNode(_component_AsSwitch, {
                customClass: 'row-wrapper',
                disabled: !_ctx.isCurrentUserAdmin,
                value: _ctx.userHasRole(_ctx.appRoles.Peer),
                onUpdate: _cache[20] || (_cache[20] = () => _ctx.toggleUserRole(_ctx.appRoles.Peer))
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t(_ctx.appRoles.Peer)), 1)
                ]),
                _: 1
              }, 8, ["disabled", "value"])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    })
  ], 64))
}